@if (view === 'sign in') {
  <div mat-dialog-title class="fx-layout-row fx-align--x-center">
    <h3>Sign In</h3>
    <div class="fx-flex-grow"></div>
    @if (configs.closeMethod == 'x' && !dialogRef.disableClose) {
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon svgIcon="x"></mat-icon>
      </button>
    }
  </div>
  <mat-dialog-content>
    <form name="signIn">
      <mat-form-field>
        <mat-label>email address</mat-label>
        <input name="email" matInput type="email" [(ngModel)]="signInForm.email">
      </mat-form-field>
      <mat-form-field>
        <mat-label>password</mat-label>
        <mbnm-password-revealer>
          <input name="password" matInput type="password" [(ngModel)]="signInForm.password">
        </mbnm-password-revealer>
      </mat-form-field>
    </form>
    @if (popUpMessage) {
      <p class="pop-up-message" [innerHTML]="popUpMessage"></p>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="fx-layout-column">
    <div class="fx-layout-row fx-align--space-between-x">
      <button (click)="signIn()" [ngClass]="{'full-width': dialogRef.disableClose}" mat-flat-button color="primary">Sign In</button>
      @if (!dialogRef.disableClose) {
        <button (click)="closeWindow()" mat-flat-button color="secondary">Cancel</button>
      }
    </div>
    <div class="fx-layout-row fx-align--space-between-x">
      <a href="javascript:void(0);" (click)="resetPassword()">Forgot Password</a>
      <a href="javascript:void(0);" (click)="view='register'">Register</a>
    </div>
  </mat-dialog-actions>
}

@if (view === 'register') {
  <div mat-dialog-title class="fx-layout-row fx-align--x-center">
    <h3>Register</h3>
    <div class="fx-flex-grow"></div>
    @if (configs.closeMethod == 'x' && !dialogRef.disableClose) {
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon svgIcon="x"></mat-icon>
      </button>
    }
  </div>
  <mat-dialog-content>
    <form>
      <mat-form-field>
        <mat-label>full name</mat-label>
        <input matInput
          name="fullname"
          required
          [(ngModel)]="registerForm.fullname">
        </mat-form-field>
        <mat-form-field>
          <mat-label>phone number</mat-label>
          <input matInput
            name="phone"
            minlength="10"
            required
            [(ngModel)]="registerForm.phonenumber">
          </mat-form-field>
          <mat-form-field>
            <mat-label>email address</mat-label>
            <input matInput
              name="email"
              type="email"
              required
              [(ngModel)]="registerForm.email">
            </mat-form-field>
            @if (page === 'checkout') {
              <mat-checkbox name="registerFlag" [(ngModel)]="createAccount">Register for an account</mat-checkbox>
            }
            @if (createAccount || page !== 'checkout') {
              <mat-form-field>
                <mat-label>password</mat-label>
                <mbnm-password-revealer>
                  <input matInput
                    type="password"
                    name="password"
                    minlength="6"
                    required
                    [(ngModel)]="registerForm.password">
                  </mbnm-password-revealer>
                </mat-form-field>
              }
              @if (createAccount || page !== 'checkout') {
                <mat-form-field>
                  <mat-label>confirm password</mat-label>
                  <mbnm-password-revealer>
                    <input matInput
                      type="password"
                      name="confirmPassword"
                      minlength="6"
                      required
                      [(ngModel)]="registerForm.confirmPassword">
                    </mbnm-password-revealer>
                  </mat-form-field>
                }
                <mat-checkbox name="newsLetter" value="SUBSCRIBE_REQUESTED"
                  (ngModelChange)="registerForm.subscriptions.newsletterEmailStatus = $event ? 'SUBSCRIBE_REQUESTED' : null"
                  [ngModel]="registerForm.subscriptions.newsletterEmailStatus">
                  Email me news & promotions
                </mat-checkbox>
                <!--
                <mat-checkbox name="smsMarketing"
                  [ngModel]="registerForm.subscriptions.smsMarketingStatus"
                  (ngModelChange)="showSMSDisclaimer($event)">
                  Text me news & promotions
                </mat-checkbox>
                -->
              </form>
            </mat-dialog-content>
            <mat-dialog-actions class="fx-layout-column">
              <div class="fx-layout-row fx-align--space-between-x">
                <button [ngClass]="{'full-width': dialogRef.disableClose}" mat-flat-button color="primary" (click)="register()">
                  @if (createAccount) {
                    Register
                  }
                  @if (!createAccount) {
                    Checkout as Guest
                  }
                </button>
                @if (!dialogRef.disableClose) {
                  <button (click)="closeWindow()" mat-flat-button color="secondary">Cancel</button>
                }
              </div>
              <div class="fx-layout-row fx-align--space-between-x">
                <a href="javascript:void(0);" (click)="resetPassword()">Forgot Password</a>
                <a href="javascript:void(0);" (click)="view='sign in'">Sign In</a>
              </div>
            </mat-dialog-actions>
          }

          @if (view === 'update password') {
            <div mat-dialog-title class="fx-layout-row fx-align--x-center">
              @if (user?.isGuest) {
                <h3 >Add Password to Register</h3>
              }
              @if (!user?.isGuest) {
                <h3 >Account Security</h3>
              }
              <div class="fx-flex-grow"></div>
              @if (configs.closeMethod == 'x' && !dialogRef.disableClose) {
                <button mat-icon-button mat-dialog-close tabindex="-1">
                  <mat-icon svgIcon="x"></mat-icon>
                </button>
              }
            </div>
            <mat-dialog-content>
              <form class="fx-layout-column"
                #passform [formGroup]="passwordFormGroup"
                (submit)="savePasswordChange()">
                @if (!user?.isGuest) {
                  <mat-form-field>
                    <mat-label>old password</mat-label>
                    <mbnm-password-revealer>
                      <input matInput
                        type="password"
                        required
                        minlength="6"
                        formControlName="old">
                      </mbnm-password-revealer>
                    </mat-form-field>
                  }
                  <mat-form-field>
                    <mat-label>new password</mat-label>
                    <mbnm-password-revealer>
                      <input matInput
                        type="password"
                        required
                        minlength="6"
                        formControlName="new">
                      </mbnm-password-revealer>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>confirm password</mat-label>
                      <mbnm-password-revealer>
                        <input matInput
                          type="password"
                          required
                          minlength="6"
                          formControlName="confirm">
                        </mbnm-password-revealer>
                      </mat-form-field>
                    </form>
                  </mat-dialog-content>
                  <mat-dialog-actions>
                    <form class="fx-layout-row fx-align--space-between-x"
                      [formGroup]="passwordFormGroup"
                      (submit)="savePasswordChange()">
                      @if (!user.isGuest) {
                        <button type="submit" mat-flat-button color="primary">Update Password</button>
                        <button type="button" mat-flat-button color="secondary" (click)="resetPasswordForm()">Cancel</button>
                      }
                      @if (user.isGuest) {
                        <button type="submit" mat-flat-button color="primary">Create Account</button>
                        <button type="button" mat-flat-button color="secondary" (click)="closeWindow()">Cancel</button>
                      }
                    </form>
                  </mat-dialog-actions>
                }
